import {Component, EventEmitter, OnInit, Output} from '@angular/core';
import {GridColumn, MxCustomizableCustomizer, MxGridCustomizerEvent, MxGridHandleOrder, ProductObj} from 'mx-core';

@Component({
    selector: 'prl-product',
    standalone: false,
    template: `
        <mx-grid class="prl-grid-screen" (customize)="onCustomize($event)">
        </mx-grid>`
})
export class PrlProductsComponent implements OnInit,
    MxGridHandleOrder<ProductObj>, MxCustomizableCustomizer<MxGridCustomizerEvent> {

    private gridColumns: Array<GridColumn> = [];

    @Output()
    customize: EventEmitter<MxGridCustomizerEvent> = new EventEmitter<MxGridCustomizerEvent>();

    ngOnInit(): void {
        this.gridColumns = [
            new GridColumn({field: 'id', sortable: true, label: 'ID', hidden: true}),
            new GridColumn({field: 'name', sortable: true, label: 'Name', columnWidth: 200, idProp: 'id'}),
            new GridColumn({field: 'description', sortable: true, label: 'Description', columnWidth: 200}),
            new GridColumn({field: 'order', label: 'Order', sortable: true, columnWidth: 200})
        ];
    }

    onCustomize(event: MxGridCustomizerEvent): void {
        event.customizeLoadRowsOnStart(true)
            .customizeRestUrl('/product/normal')
            .customizeColumns(this.gridColumns)
            .customizeProps({
                noPagination: true,
                sortActive: 'name',
                sortDirection: 'asc',
                selectionMode: 'multi'
            })
            .customizeOrder(this);

        this.customize.emit(event);
    }


    getOrder(record: ProductObj): number {
        return record.order;
    }

    setOrder(order: number, record: ProductObj) {
        record.order = order;
        return record;
    }
}
